export const INITIAL_STATE = {
    details: {},
    factors: {},
    criticalFactors: {
        creditFactors: [],
        equityFactors: [],
    },
};
